import React from "react";
import {
  Bar,
  YAxis,
  XAxis,
  Tooltip,
  ResponsiveContainer,
  Legend,
  BarChart,
  CartesianGrid,
} from "recharts";
import PropTypes from "prop-types";
import CustomTooltip from "./Tooltip";
import ChartWrapper from "./ChartWrapper";
import CustomLegend from "./Legend";

const Chart = ({ title, data, dataKey }) => (
  <ChartWrapper title={title}>
    <ResponsiveContainer>
      <BarChart
        barCategoryGap={5}
        layout="vertical"
        width={500}
        height={800}
        data={data}
        margin={{
          top: 0,
          right: 0,
          left: 0,
          bottom: 0,
        }}
      >
        <XAxis
          tick={{ fontSize: 12 }}
          type="number"
          axisLine={false}
          tickLine={false}
        />
        <YAxis
          tick={{ fontSize: 12 }}
          width={80}
          interval={0}
          type="category"
          tickLine={false}
          dataKey={dataKey}
        />
        <Tooltip content={<CustomTooltip />} />
        <Legend
          verticalAlign="top"
          align="left"
          iconType="square"
          iconSize={10}
          wrapperStyle={{ marginLeft: 0 }}
          content={<CustomLegend />}
        />
        <CartesianGrid horizontal={false} />
        <Bar
          name="Estimated tracers needed"
          dataKey="tracers_needed"
          stackId="b"
          fill="#44A3B0"
        />
        <Bar
          name="Current tracers"
          dataKey="current_tracers"
          stackId="a"
          fill="#2891C9"
        />
        <Bar
          name="Potential additional tracers"
          dataKey="additional_potential_tracers"
          stackId="a"
          fill="#88C6E7"
        />
      </BarChart>
    </ResponsiveContainer>
  </ChartWrapper>
);

Chart.defaultProps = {
  title: null,
};

Chart.propTypes = {
  title: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  dataKey: PropTypes.string.isRequired,
};

export default Chart;
